var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Add"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add",
    clipPath: "url(#clip-Add)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32762",
    "data-name": "Path 32762",
    d: "M9.173,13.8h1.543V10.716H13.8V9.173H10.716V6.086H9.173V9.173H6.086v1.543H9.173Zm-4.63,3.086A1.548,1.548,0,0,1,3,15.346V4.543A1.548,1.548,0,0,1,4.543,3h10.8a1.548,1.548,0,0,1,1.543,1.543v10.8a1.548,1.548,0,0,1-1.543,1.543Zm0-1.543h10.8V4.543H4.543Zm0-10.8v0Z",
    transform: "translate(-2.944 -2.945)",
    fill: "#0071cd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.a974c304a13a7928713e320f228e15a8.svg";
export { ForwardRef as ReactComponent };